import underscored from 'underscore.string/underscored';

angular.module('gym.contacts').controller('MembershipRealignmentsCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$http", "$window", "$filter", "flash", "loadingAnimation", "EmploymentService", "MessageService", "invoice", function($scope, $rootScope, $state, $stateParams, $http, $window, $filter, flash, loadingAnimation, EmploymentService, MessageService, invoice) {
  var baseUrl, contactType, gym, isNewDate;
  $scope.gym = gym = $rootScope.gym;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.invoice = invoice.plain();
  $scope.data = {
    new_date: invoice.due_date
  };
  contactType = `${underscored(invoice.contact_type)}s`;
  baseUrl = `/gyms/${gym.id}/${contactType}/${invoice.contact_id}/membership_realignments`;
  if (!$scope.permissions.manage_payment_status) {
    $scope.cancel();
  }
  isNewDate = function() {
    return $scope.data.new_date !== $scope.invoice.due_date;
  };
  $scope.onChange = function() {
    var params, url;
    if (!isNewDate()) {
      return;
    }
    url = `${baseUrl}/expected_invoice_changes?invoice_id=${$stateParams.invoice_id}`;
    params = {
      membership_realignment: {
        first_invoice_rescheduled_to: $scope.data.new_date
      }
    };
    $scope.isLoading = true;
    return $http.post(url, params).then(function(response) {
      $scope.isLoading = false;
      $scope.invoiceChanges = response.data.invoice_changes;
      return $scope.visibleInvoiceChanges = $scope.invoiceChanges.length > 5 ? $scope.invoiceChanges.slice(0, 5) : $scope.invoiceChanges;
    }, function(response) {
      flash.error = response.data.error;
      $scope.invoiceChanges = [];
      return $scope.visibleInvoiceChanges = [];
    });
  };
  $scope.showMore = function() {
    return $scope.visibleInvoiceChanges = $scope.invoiceChanges;
  };
  $scope.isReady = function() {
    var ref;
    return ((ref = $scope.invoiceChanges) != null ? ref.length : void 0) && !$scope.isLoading && isNewDate();
  };
  $scope.submitLabel = function() {
    var ref, ref1;
    if ((ref = $scope.invoiceChanges) != null ? ref.length : void 0) {
      return `Reschedule ${(ref1 = $scope.invoiceChanges) != null ? ref1.length : void 0} payments`;
    } else {
      return "Reschedule";
    }
  };
  $scope.submit = function() {
    var date, messageParams;
    date = $filter('date')(invoice.due_date, 'dd MMM yyyy');
    messageParams = {
      title: 'Are you sure?',
      displayOkButton: true,
      confirmButtonText: 'Confirm',
      message: [`Please confirm you would like to reschedule all future payments for this membership, starting from ${date}.`]
    };
    return MessageService.message(messageParams).then(function() {
      var params, url;
      $scope.isLoading = true;
      loadingAnimation.show();
      params = {
        membership_realignment: {
          first_invoice_rescheduled_to: $scope.data.new_date
        }
      };
      url = `${baseUrl}?invoice_id=${$stateParams.invoice_id}`;
      return $http.post(url, params).then(function() {
        flash.success = "Rescheduled successfully";
        return $scope.cancel();
      }, function() {
        loadingAnimation.hide();
        $scope.isLoading = false;
        return flash.error = "Request could not be completed. Please try again";
      });
    });
  };
  return $scope.cancel = function() {
    var params;
    if ($stateParams.from_contact_page) {
      params = {
        contactType: `${underscored(invoice.contact_type)}s`,
        contactId: invoice.contact_id,
        tab: 'payments'
      };
      return $state.go('gym.contacts.edit', params);
    } else {
      return $state.go('gym.invoices');
    }
  };
}]);
